module.exports = __webpack_public_path__ + "exo-latin-500.6d4c29b8d9640e68f812.woff2";


//////////////////
// WEBPACK FOOTER
// /srv/prod/FitRadioAdmin2/node_modules/typeface-exo/files/exo-latin-500.woff2
// module id = ../../../../typeface-exo/files/exo-latin-500.woff2
// module chunks = styles